import React, { useEffect, useState } from "react";
import { Col, Row, Carousel, Spin } from 'antd';
import { offer_bg, offer_bg_2, indigoFlight } from '../../../utils/ImagePath';
import { Link } from "react-router-dom";
import { FaChevronRight } from 'react-icons/fa';
import { getFlightOffersList } from "../../../services/flight/flightServices";


const Offers = () => {

    const [offers, setOffers] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let offerType = "homeoffer"
        const fetchOffers = async () => {
            try {
                setLoading(true);
                const response = await getFlightOffersList(offerType);
                setOffers(response);
            } catch (error) {
                console.error("Error fetching offers:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchOffers();
    }, []);

    return (
        <>
            <section className="offer-area">
                <div className="container">
                    <Row gutter={20}>
                        <Col lg={24}>
                            {loading ? (
                                <div className="text-center py-5">
                                    <Spin size="large" />
                                </div>
                            ) : offers.length > 0 ? (
                                <Carousel
                                    autoplay
                                    dots={false}
                                    slidesToShow={3}
                                    slidesToScroll={1}
                                    arrows={true}
                                    draggable={true}
                                    swipe={true}
                                    infinite={true}
                                    responsive={[
                                        {
                                            breakpoint: 768,
                                            settings: { slidesToShow: 1, slidesToScroll: 1 },
                                        },
                                    ]}
                                >
                                    {offers.map((offer, index) => (
                                        <div key={offer.id || index}>
                                            <Link
                                                to={
                                                    (() => {
                                                        const type = offer.applicable_type_name?.toLowerCase();
                                                        switch (type) {
                                                            case "hotel":
                                                                return "/hotels";
                                                            case "flight":
                                                                return "/offers";
                                                            case "holiday":
                                                                return "/holiday";
                                                            default:
                                                                return "/offers";
                                                        }
                                                    })()
                                                }
                                                className={`offer-card d-block ${offer.applicable_type_name?.toLowerCase() || ""
                                                    } background-image text-start mx-2`}
                                                style={{
                                                    textDecoration: "none",
                                                    color: "inherit",
                                                }}
                                            >
                                                <img
                                                    src={offer.image_url || offer_bg}
                                                    alt={offer.title || "Offer"}
                                                    className="offer-img"
                                                    loading="eager"
                                                    decoding="async"
                                                />
                                            </Link>
                                        </div>
                                    ))}
                                </Carousel>
                            ) : (
                                <p className="text-center py-4 invisible">No offers available right now.</p>
                            )}
                        </Col>
                    </Row>
                </div >
            </section >

            <section className='mobile-offer ptb-70 pb-0 d-none'>
                <div className='container'>
                    <div className='d-flex align-items-center justify-content-between mb-4'>
                        <h2>Flights Offers</h2>
                        <a className='fw-bold d-flex align-items-center gap-2 text-primary' aria-label="See More Flights" href="/offers">View All <FaChevronRight /> </a>
                    </div>
                    <Row gutter={20} className=''>
                        <Col xs={12}>
                            <div className='flight_offer'>
                                <img loading="lazy" src={indigoFlight} alt="" className='main-img' />
                                <div className='content'>
                                    <div className='d-flex align-items-center gap-2 flight_name'>
                                        <img loading="lazy" src='' alt="" />
                                        <h5 className='bg-primary'>Indigo</h5>
                                    </div>
                                    <h3>Get Flat 30% OFF on Payment Via RBL Bank</h3>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='flight_offer'>
                                <img loading="lazy" src={indigoFlight} alt="" className='main-img' />
                                <div className='content'>
                                    <div className='d-flex align-items-center gap-2 flight_name'>
                                        <img loading="lazy" src='' alt="" />
                                        <h5 className='bg-primary'>Indigo</h5>
                                    </div>
                                    <h3>Get Flat 30% OFF on Payment Via RBL Bank</h3>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='flight_offer'>
                                <img loading="lazy" src={indigoFlight} alt="" className='main-img' />
                                <div className='content'>
                                    <div className='d-flex align-items-center gap-2 flight_name'>
                                        <img loading="lazy" src='' alt="" />
                                        <h5 className='bg-primary'>Indigo</h5>
                                    </div>
                                    <h3>Get Flat 30% OFF on Payment Via RBL Bank</h3>
                                </div>
                            </div>
                        </Col>
                        <Col xs={12}>
                            <div className='flight_offer'>
                                <img loading="lazy" src={indigoFlight} alt="" className='main-img' />
                                <div className='content'>
                                    <div className='d-flex align-items-center gap-2 flight_name'>
                                        <img loading="lazy" src='' alt="" />
                                        <h5 className='bg-primary'>Indigo</h5>
                                    </div>
                                    <h3>Get Flat 30% OFF on Payment Via RBL Bank</h3>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>

            </section>
        </>
    )
}

export default Offers



